import React from "react";
import "./styles.css";
import ReactDOM from "react-dom";

export default function PopUpAlert(props) {
    let { titulo, mensaje, open, showAceptar = false } = props;

    return ReactDOM.createPortal(
        <>
            <div
                className="contenedorGeneralAlertSoftwone"
                onClick={() => {
                    open(false);
                }}
            >
                <div
                    className="contenedorInternoAlertSoftwone"
                    onClick={e => {
                        e.stopPropagation();
                    }}
                >
                    <h1>{titulo}</h1>
                    <h2>{mensaje}</h2>
                    {
                        showAceptar?
                        <button
                            onClick={() => {
                                open(false);
                            }}
                            className="buttonAlertSoftwone"
                        >
                            ACEPTAR
                        </button>
                        :
                        <>
                        </>
                    }
                </div>
            </div>
        </>,
        document.getElementById("alert")
    );
}
